import { Modal } from "antd";
import styled from "styled-components";

export const ModalOverlay = styled(Modal)`
  width: auto !important;
  height: auto !important;

  .ant-modal-content {
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    padding: 40px 30px 40px 30px;
    border-radius: 15px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: "Arial", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.textColor};
`;

export const ContentLabel = styled.label`
  font-family: "Arial", sans-serif;
  font-size: 26px;
  font-weight: 300;
  color: ${(props) => props.textColor};
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const ButtonOK = styled.button`
  margin-top: 50px;
  width: 100%;
  height: 60px;
  background: ${(props) => props.bgButtonOk};
  color: ${(props) => props.textButtonOk};
  border: none;
  border-radius: 5px;
  font-size: 22px;
  cursor: pointer;
  font-weight: bold;
`;
